"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontTypeMixin = void 0;
var _fontSizeTypeMixin = require("./fontSizeTypeMixin");
var _fontWeightTypeMixin = require("./fontWeightTypeMixin");
var _inlineMediaQueryMixin = require("./inlineMediaQueryMixin");
var _lineHeightTypeMixin = require("./lineHeightTypeMixin");
/** @mixin fontTypeMixin */
/**
 * Adds styling for font attributes.
 *
 * @example
 * import { fontTypeMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *    ${fontTypeMixin}
 * `';
 *
 * <Component fontType="h1">H1 styling</Component>
 * <Component fontType={{ default: 'h1', sm_lte: 'h2' }}>Responsive styling</Component>
 *
 * @method
 * @param {object} props
 * @param {string|object} [props.fontType] - The font type string or an object that maps breakpoints
 *    to font type strings
 * @return {Interpolation}
 */
var fontTypeMixin = function fontTypeMixin(props) {
  if (!props.fontType) {
    return '';
  }
  return (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('fontType', function (mediaProps) {
    return [(0, _fontWeightTypeMixin.fontWeightTypeMixin)(mediaProps), (0, _fontSizeTypeMixin.fontSizeTypeMixin)(mediaProps), (0, _lineHeightTypeMixin.lineHeightTypeMixin)(mediaProps)];
  })(props);
};
exports.fontTypeMixin = fontTypeMixin;